module.exports = __webpack_public_path__ + "static/media/icon-library-full@2x.eba0ac14.png";